import DatetimeUtils from "../../../gd/utils/datetime-utils";
import Meeting from "../meeting";

export default class SessionMeetingsCollection {

    private _meetingById    : any
    private _meetings    : any[]    = []

    constructor(meetings:any) {
        this.reset(meetings, false);
    }

    get(meetingId:ID) {
        return this._meetingById[meetingId];
    }

    map(callback:callback) {
        return _.map(this._meetings, callback);
    }

    groupedByDate(forceToday = false) {
        let res = _.chain(this._meetings)
            .orderBy(meeting=>meeting.startMoment.format("x"))
            .groupBy(meeting=>meeting.startMoment.format("YYYY-MM-DD"))
            .toPairs()
            .map(group=>({
                date: DatetimeUtils.dateToMoment(group[0]),
                items: group[1]
            }))
            .value();

        if (forceToday) {
            const today = moment();
            const hasToday = _.find(res, group=>group.date.isSame(today, 'day'));
            if (!hasToday) res.push({date: today, items: []})
            res = _.orderBy(res, group=>group.date.format('x'));
        }

        return res;
    }

    getForDate(moment:Moment) {
        const group = moment ? _.find(this.groupedByDate(), group=>group.date.isSame(moment,'day')) : null;
        return group ? group.items : [];
    }

    reset(meetings:any[], busEvent=true) {

        this._meetings = [];
        this._meetingById = {};

        _.map(meetings, meetingJson=>{
            const meeting = new Meeting(meetingJson);
            this._meetings.push(meeting);
            this._meetingById[meeting.id] = meeting;
        })

    }

    add(meetingJson:any, busEvent=true) {

        if (this.get(meetingJson.id)) {
            this.remove(meetingJson.id);
        }

        const meeting = new Meeting(meetingJson);
        this._meetings.push(meeting);
        this._meetingById[meeting.id] = meeting;

        if (busEvent) gd.bus.triggerEvent('gd.session.meetings:add', meeting);
    }

    remove(meetingId:ID, busEvent=true) {
        const meeting = this.get(meetingId);

        if (meeting) {
            this._meetings.remove(meeting);
            delete this._meetingById[meeting.id];
        }

        if (busEvent) gd.bus.triggerEvent('gd.session.meetings:remove', meetingId);
    }

    update(meetingId:ID, newData:any, busEvent = true) {

        // console.log("SessionMeetingsCollection.udate()", meetingId, newData)

        // we ignore other updates if dont need them
        if (newData.name || newData.projectId || newData.startMoment || newData.endMoment) {
            const meeting = this._meetingById[meetingId];

            if (!meeting) {
                console.error("#hdjdh383267 - bad case no meeting found in session")
                return
            }

            meeting.update(newData);

            if (busEvent) gd.bus.triggerEvent('gd.session.meetings:update', newData);

            // TODO:
            // gd.session.meeting but update event needed here
            // i.e. gd.bus.triggerEvent('gd.session.meetings:update') = rerender my work or so....
        }
    }

    get models() {
        return this._meetings;
    }
}
